'use client';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import { useEffect } from 'react';

export function CSPostHogProvider({
  children,
  posthogKey
}: {
  children: React.ReactNode;
  posthogKey: string;
}) {
  useEffect(() => {
    if (!posthogKey) return;
    posthog.init(posthogKey, {
      // First-party proxy (rewrites in next.config.js) — direct requests to
      // us.i.posthog.com are dropped by ad blockers and Safari's tracker
      // blocklists, which silently loses all events for those respondents.
      api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST || '/ingest',
      ui_host: 'https://us.posthog.com',
      autocapture: {
        url_allowlist: ['trypulseiq.com', 'meetcorvus.ai', 'app.meetcorvus.ai'] // Or use regular expressions for more flexibility
      },
      person_profiles: 'identified_only' // or 'always' to create profiles for anonymous users as well
      // defaults: '2025-05-24'
    });
  }, []);
  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
}
